import { network } from 'services/network';

import { QueryParams } from 'api/mutations/updateTemplateText.mutation';

export const updateTemplateText = (params: QueryParams) => {
    return network.post('api/bo/narratives/updateTemplateText', params).then((response) => {
        return response.data;
    });
};
